import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationAccountActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Account/AccountBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationAccount"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationAccount"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationAccountActivity)
